export const LOYALTY_ICON_COLOR = '#FF8732';
export const LOYALTY_ICON_NAME = 'bkCrown';
